/* global localStorage */

import * as Promise from 'bluebird';
import { getAgentToken, getAgentCapabilityToken } from './agent';
import { destroyWorker, initWorker } from '../../taskrouter';
import { initDevice } from '../../device';
import { logout, refreshSession } from './index';
import { getAll as jobGetAllAction } from './job';
import { ROUTES, SKIP_AGENT_KIT_NEXT_LOGIN, SKIP_GUIDELINES_ON_LOGIN } from '../../../Constants';
import { getIsUserVendor, getProfile, getTOUAcceptance } from './me';
import { store } from '../index';
import ActionTypes from '../action-types';

export function initialiseTwilioWorkers(history) {
  return async dispatch => {
    try {
      await Promise.all([dispatch(getAgentToken()), dispatch(getAgentCapabilityToken())]);

      await initDevice();

      await Promise.fromCallback(callback => initWorker(history, callback));
    } catch (err) {
      destroyWorker();
      throw err;
    }
  };
}

export async function redirectToFirstPage(history) {
  const showGuidelines = JSON.parse(localStorage.getItem(SKIP_GUIDELINES_ON_LOGIN));

  if (showGuidelines) {
    history.push(ROUTES.GUIDELINES);
    return;
  }

  try {
    const { me } = store.getState();

    if (me.agentIsVendor) {
      const termsOfUseUpdateAt = await store.dispatch(getTOUAcceptance());

      if (!termsOfUseUpdateAt) {
        history.push(ROUTES.VENDOR_PRIVACY_TERMS);
        return;
      }
    }
  } catch (err) {
    console.log(err);
  }

  if (!localStorage.getItem(SKIP_AGENT_KIT_NEXT_LOGIN)) {
    history.push(ROUTES.AGENT_KIT);
    return;
  }

  if (history.location.pathname === ROUTES.LOADING) {
    history.goBack();
    return;
  }

  history.push(ROUTES.HOME);
}

export function initializeSession(history) {
  return async dispatch => {
    try {
      const proms = [
        dispatch(getIsUserVendor()),
        dispatch(initialiseTwilioWorkers(history)),
        dispatch(getProfile())
      ];
      await Promise.all(proms);
    } catch (err) {
      await dispatch(logout());

      if (history.location.pathname === ROUTES.LOGIN) {
        throw err;
      }
    }
  };
}

export function refreshSessions(history) {
  history.push(ROUTES.LOADING);
  return async dispatch => {
    try {
      await Promise.all([
        dispatch(refreshSession()),
        dispatch(initializeSession(history)),
        dispatch(jobGetAllAction())
      ]);
    } catch (err) {
      await logout();
    }
    await redirectToFirstPage(history);
  };
}

export function setAppNotification(message) {
  return async dispatch => {
    dispatch({ type: ActionTypes.SET_APPLICATION_NOTIFICATION, payload: message });
  };
}
